// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__YnsW3","secondary":"Button_secondary__yK2r9","warn":"Button_warn__l-Avt","icon":"Button_icon__Bp-YI","disabled":"Button_disabled__L5iFo"};